export default "__VITE_ASSET__D3EI0Arl__"